import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'state/store-hooks';
import { postMessage } from 'utils/helper-functions/post-message';

export type CashierHeaderElement = 'cashier_back_button' | 'cashier_close_button';

export const useCashierHeaderEvents = (page: string = 'payment-method') => {
  const { cid, orderId, currentDomain, isRedirect } = useAppSelector(
    (state) => ({
      cid: state.profileInfo?.customer?.pin,
      orderId: state.profileInfo?.order_id,
      currentDomain: state.initTheme?.currentDomain,
      isRedirect: !!state.resultOfPay?.redirect_url,
    }),
    shallowEqual,
  );

  const pageName = isRedirect ? 'payment-processor' : page;

  const notify = useCallback(
    (element: CashierHeaderElement) => {
      postMessage({
        event_type: 'client_click',
        element,
        page: pageName,
        ...(currentDomain && {
          cid,
          order_id: orderId,
        })
      }, currentDomain);
    },
    [cid, orderId, page, currentDomain, pageName],
  );

  const notifyBack = useCallback(() => notify('cashier_back_button'), [notify]);
  const notifyClose = useCallback(() => notify('cashier_close_button'), [notify]);

  return { notify, notifyBack, notifyClose };
};
